module.exports = __webpack_public_path__ + "../resources/images/SkyCode_19-a763bac3883a9e3bd1245c64c3154169.svg";